import { Module } from '@nestjs/common';
import { FinancialsService } from './financials.service';
import { FinancialsController } from './financials.controller';
import { FinancialsEntity } from '@crm/dto';
import { TypeOrmModule } from '@nestjs/typeorm';

@Module({
  controllers: [FinancialsController],
  providers: [FinancialsService],
  imports: [TypeOrmModule.forFeature([FinancialsEntity])],
})
export class FinancialsModule {}
